/** Tracks in-flight saves by key so a second save for the same Task can't race the first. */
export class PendingKeys {
  private readonly keys = new Set<string>();

  has(key: string): boolean {
    return this.keys.has(key);
  }

  /** Runs `fn` unless `key` is already running. Resolves `false` when refused. */
  async run(key: string, fn: () => Promise<void>): Promise<boolean> {
    if (this.keys.has(key)) {
      return false;
    }
    this.keys.add(key);
    try {
      await fn();
      return true;
    } finally {
      this.keys.delete(key);
    }
  }
}
